import { render } from "./ProjectFilters.vue?vue&type=template&id=a11b1bba"
import script from "./ProjectFilters.vue?vue&type=script&lang=js"
export * from "./ProjectFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__